<template>
  <div
    class="cursor-pointer rounded-md bg-green-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-700"
  >
    <slot></slot>
  </div>
</template>
